import { initializeAuthCallbacks, initializeAxiosRequestInterceptor } from '@sit/client-shared';
import { authStore } from '@web/redux/auth-store';
import { useEffect } from 'react';
import { useUpdateAccessToken } from './access-token';

export function useInitializeClientShared() {
  const setToken = useUpdateAccessToken();
  useEffect(() => {
    initializeAuthCallbacks({
      getToken: () => authStore.getToken() || undefined,
      getRefreshToken: () => authStore.getRefreshToken() || undefined,
      setToken: (token) => {
        void setToken(token);
      },
      onLogout: () => {
        authStore.logout();
      },
    });
  }, [setToken]);
  useEffect(() => {
    initializeAxiosRequestInterceptor();
  }, []);
}
